import { create } from "../../../../../common/utils/zustand_state_manager";

type State = {
  Cargo: string | null;
  TIPO_TREINAMENTO: string | null;
  ID_OBRA: number;
};


type Action = {
  setFilters: (filters: Partial<State>) => void;
  clearFilters: () => void;
};


export const initialFiltersValues: State = {
  Cargo: "",
  TIPO_TREINAMENTO: "",
  ID_OBRA: 0,
};

export const usePlanoTreinamentoFilters = create<State & Action>((set) => ({
  ...initialFiltersValues,

  setFilters: (filters) => set((state) => ({ ...state, ...filters })),

  clearFilters: () => set(initialFiltersValues),
}));